module.exports = __webpack_public_path__ + "static/media/orange_tick.6cac231f.svg";